<template>
  <section
    class="visibility-auto group relative overflow-hidden rounded-xl"
    :class="{
      'max-sm:overflow-visible max-sm:rounded-none': mobileLayout,
    }"
    data-cy-course-card
    :data-cy-course-card-id="course.id"
    :style="{
      width: width ? `${width}px` : undefined,
      '--borderColor': mainTagColors?.border,
      '--backgroundColor': mainTagColors?.background,
    }"
  >
    <nuxt-link
      class="relative block aspect-[3/4] w-full"
      :class="{
        'max-xs:grid-cols-[80px_1fr] max-sm:grid max-sm:aspect-auto max-sm:grid-cols-[110px_1fr] max-sm:items-center max-sm:gap-3':
          mobileLayout,
      }"
      :to="course._links.page"
    >
      <div
        class="absolute h-full w-full overflow-hidden rounded-xl"
        :class="{
          'max-sm:static max-sm:aspect-square': mobileLayout,
        }"
      >
        <app-image
          v-if="course.teacher"
          :alt="course.teacher.full_name!"
          class="h-full w-full object-cover transition duration-500 group-hover:scale-105"
          :class="{
            'max-sm:group-hover:scale-100': mobileLayout,
          }"
          :src="course.teacher.avatar_url"
          :width="600"
        />
      </div>

      <course-card-content
        class="h-full w-full bg-gradient-to-t from-black/70 from-20% to-70% p-4 text-white transition group-hover:translate-y-1 group-hover:opacity-0"
        :class="{
          'max-sm:from-transparent max-sm:p-0 max-sm:text-black max-sm:group-hover:translate-y-0 max-sm:group-hover:opacity-100':
            mobileLayout,
        }"
        :course="course"
        :mobile-layout="mobileLayout"
        :show-next-session="showNextSession"
      />
    </nuxt-link>

    <div
      class="bg-(--backgroundColor) absolute inset-0 hidden rounded-xl opacity-0 mix-blend-screen transition group-hover:opacity-80 sm:block"
    />

    <div
      class="border-(--borderColor) absolute inset-0 hidden overflow-hidden rounded-xl border-2 opacity-0 transition-all duration-300 group-hover:opacity-100 group-hover:backdrop-blur-lg sm:block"
    >
      <course-card-overlay
        class="h-full"
        :course="course"
        :main-tag="mainTag"
        :main-tag-colors="mainTagColors"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { CourseListView } from "~/business-areas/course/composables/course-list.hook";
import {
  type CarouselProvidedState,
  CarouselProvideKey,
} from "~/shared/carousel/carousel.model";

const properties = defineProps<{
  course: CourseListView;
  showNextSession?: boolean;
  mobileLayout?: boolean;
}>();

const width = computed(
  () =>
    inject<CarouselProvidedState | null>(CarouselProvideKey, null)?.itemWidth,
);

const mainTag = computed(() => properties.course.tags[0]);

const mainTagColors = computed(() => {
  if (!mainTag.value) return;

  return {
    border: hexToHSLA(mainTag.value.color, {
      luminance: 80,
      saturation: 50,
    }),
    background: hexToHSLA(mainTag.value.color, {
      luminance: 85,
      saturation: 70,
    }),
    text: hexToHSLA(mainTag.value.color, {
      luminance: 15,
      saturation: 70,
    }),
  };
});
</script>
